import { render } from "./menu.vue?vue&type=template&id=23932baa&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=23932baa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-23932baa"

export default script